import { use } from 'react';
import type { AuthUser } from './AuthContext';
import { AuthContext } from './AuthContext';

function useAuthContext() {
	const ctx = use(AuthContext);
	if (!ctx) throw new Error('useAuth hooks must be used within an AuthProvider');
	return ctx;
}

/** Returns the current authenticated user, or null if not logged in. */
export function useCurrentUser(): AuthUser | null {
	return useAuthContext().user;
}

/** Returns true if the current user has the admin role. */
export function useIsAdmin(): boolean {
	return useAuthContext().user?.isAdmin ?? false;
}

/** Returns a function to sign out the current user. */
export function useSignOut(): () => void {
	return useAuthContext().signOut;
}

/** Returns the label for the account action supplied by the active auth boundary. */
export function useAccountActionLabel(): string {
	return useAuthContext().accountActionLabel;
}
